import datepicker from 'js-datepicker';
import Scrollbar from 'smooth-scrollbar';

export default () => {
    const cont = document.querySelector('.property-search__box');
    if (cont) {
        const labels = cont.querySelectorAll('.selecteble__option');
        const labelCalendar = cont.querySelector('.selecteble__option--calendar');

        labels.forEach(label => {
            const box = label.nextElementSibling;
            const boxScroll = box.querySelector('.selecteble__box--inner');
            const overlay = label.previousElementSibling;
            const options = box.querySelectorAll('.selecteble__option--select');
            const thisCont = label.parentNode;
            const hidInp = thisCont.querySelector('input[type="hidden"]');

            if (boxScroll) {
                Scrollbar.init(boxScroll, {
                    alwaysShowTracks: true
                })
            }

            label.addEventListener('click', () => {
                openSelectBox(box, overlay);
            })

            options.forEach(option => {
                option.addEventListener('click', () => {
                    hidInp.value = option.dataset.value;
                    closeSelectBox(box, overlay);
                    label.innerHTML = option.dataset.value;
                })
            })

            box.addEventListener('click', () => {
                closeSelectBox(box, overlay);
                calendar.calendarContainer.classList.remove('active');
            })

            overlay.addEventListener('click', () => {
                closeSelectBox(box, overlay);
                calendar.calendarContainer.classList.remove('active');
            })
        })

        function openSelectBox(box, overlay) {
            overlay.classList.add('active')
            box.classList.add('active')
            const scrollbar = Scrollbar.get(box.querySelector('.selecteble__box--inner'));
            if (scrollbar) scrollbar.update();
        }

        function closeSelectBox(box, overlay) {
            overlay.classList.remove('active')
            box.classList.remove('active')
        }


        const calendar = datepicker('.selecteble__box--calendar', {
            startDay: 1,
            navigationAsDateFormat: true,
            nextText: 'later',
            prevText: 'M',
            changeMonth: false,
            showAllDates: true,
            disableYearOverlay: true,
            minDate: new Date(),

            onMonthChange: instance => {
                instance.calendarContainer.parentElement.querySelector('.selecteble__box').style.bottom = instance.calendarContainer.offsetHeight + 'px';
                setMonthName(instance)
                // addDatesHoverEffect(instance)

                const checkInInput = instance.calendarContainer.parentElement.querySelector('[name="date_in"]');
                const checkOutInput = instance.calendarContainer.parentElement.querySelector('[name="date_out"]');

                const startDate = new Date(checkInInput.value);
                const endDate = new Date(checkOutInput.value);

                if (startDate != 'Invalid Date') {
                    setRangeClass(instance, startDate, 'qs-range-start')
                }

                if (endDate != 'Invalid Date') {
                    setRangeClass(instance, endDate, 'qs-range-end')

                    let startMiddle;
                    if (instance.calendarContainer.querySelector('.qs-range-start')) {
                        startMiddle = instance.calendarContainer.querySelector('.qs-range-start');
                        addMiddleLabels(startMiddle)
                    } else if ((startDate.getFullYear() < instance.currentYear || startDate.getMonth() < instance.currentMonth) &&
                        (endDate.getFullYear() > instance.currentYear || endDate.getMonth() > instance.currentMonth)) {
                        startMiddle = instance.calendarContainer.querySelectorAll('.qs-day')[instance.calendarContainer.querySelectorAll('.qs-day').length - 1];
                        addMiddleLabels(startMiddle)
                    } else if (instance.calendarContainer.querySelector('.qs-range-end')) {
                        startMiddle = instance.calendarContainer.querySelectorAll('.qs-day')[instance.calendarContainer.querySelectorAll('.qs-day').length - 1];
                        addMiddleLabels(startMiddle)
                    }
                }
            },

            onSelect: (instance, date) => {
                setMonthName(instance)

                const checkInInput = instance.calendarContainer.parentElement.querySelector('[name="date_in"]');
                const checkOutInput = instance.calendarContainer.parentElement.querySelector('[name="date_out"]');
                const labelEl = instance.calendarContainer.parentElement.querySelector('.selecteble__option');
                const currDateEl = instance.calendarContainer.querySelector('.qs-active');

                const dateObj = new Date(date);
                const oldText = labelEl.innerHTML;
                let labelText = `${dateObj.getMonth() + 1}.${dateObj.getDate()}.${dateObj.getFullYear()}`;

                let month = dateObj.getMonth() + 1;
                let monthFormat = (month.toString().length < 2 ? "0" + month.toString() : month);
                let day = (dateObj.getDate().toString().length < 2 ? "0" + dateObj.getDate().toString() : dateObj.getDate());
                let year = dateObj.getFullYear();
                let newDateFormat = year + "-" + monthFormat + "-" + day;


                if (!checkInInput.value) {
                    checkInInput.value = newDateFormat;
                    labelEl.innerHTML = `From ${labelText}`;
                    currDateEl.classList.add('qs-range-start')
                } else if (!checkOutInput.value) {
                    if (Date.parse(checkInInput.value) > Date.parse(date)) {
                        checkInInput.value = newDateFormat;
                        labelEl.innerHTML = `From ${labelText}`;
                        removeStartLabels(instance)
                        currDateEl.classList.add('qs-range-start')
                    } else {
                        checkOutInput.value = newDateFormat;
                        labelEl.innerHTML = `${oldText} To ${labelText}`;
                        currDateEl.classList.add('qs-range-end')
                        const startMiddle = instance.calendarContainer.querySelector('.qs-range-start') || instance.calendarContainer.querySelector('.qs-num');
                        addMiddleLabels(startMiddle)

                        document.querySelectorAll('.selecteble--overlay, .selecteble__box, .qs-datepicker-container').forEach(function (item){
                            item.classList.remove('active');
                        });
                    }
                } else {
                    checkInInput.value = newDateFormat;
                    checkOutInput.value = '';
                    labelEl.innerHTML = `From ${labelText}`;
                    removeStartLabels(instance)
                    removeMiddleLabels(instance)
                    removeEndLabels(instance)
                    currDateEl.classList.add('qs-range-start')
                }
            }
        })

        labelCalendar.addEventListener('click', () => {
            calendar.calendarContainer.classList.add('active');
            calendar.calendarContainer.parentElement.querySelector('.selecteble__box').style.bottom = calendar.calendarContainer.offsetHeight + 'px';
            setMonthName(calendar)
            // addDatesHoverEffect(calendar)
        })

        // function addDatesHoverEffect(instance) {
        //   instance.calendarContainer.querySelectorAll('.qs-num').forEach((num, i) => {
        //     num.addEventListener('mouseenter', () => {
        //       const startDate = instance.calendarContainer.querySelector('.qs-range-start');
        //       const endDate = instance.calendarContainer.querySelector('.qs-range-end');
        //
        //       if (startDate && !endDate) {
        //         removeHoverLabels(instance)
        //         let startElem;
        //         addHoverLabels(startElem, num)
        //       }
        //     })
        //
        //     num.addEventListener('mouseleave', () => {
        //       num.classList.remove('qs-range-hover')
        //     })
        //   });
        // }

        function setMonthName(instance) {
            const prev = instance.calendarContainer.querySelector('.qs-left');
            const next = instance.calendarContainer.querySelector('.qs-right');

            const prevMonth = instance.currentMonth - 1 < 0 ? 11 : instance.currentMonth - 1;
            const nextMonth = instance.currentMonth + 1 > 11 ? 0 : instance.currentMonth + 1;

            const arrowRight =  '<img src="wp-content/themes/minthis/site-origin-sources/images/icons/Icon_Arrow_Right.png" alt="right"' + '/>';
            const arrowLeft =  '<img src="wp-content/themes/minthis/site-origin-sources/images/icons/Icon_Arrow_Left.png" alt="left"' + '/>';
            // const prevYear = instance.currentMonth == 0 ? instance.currentYear - 1 : instance.currentYear;
            // const nextYear = instance.currentMonth == 11 ? instance.currentYear + 1 : instance.currentYear;

            prev.innerHTML = `<span class="qs-month">${arrowLeft}</span>`;
            next.innerHTML = `<span class="qs-month">${arrowRight}</span>`;
        }

        function removeStartLabels(instance) {
            instance.calendarContainer.querySelectorAll('.qs-num').forEach((el, i) => {
                el.classList.remove('qs-range-start')
            });
        }

        function removeEndLabels(instance) {
            instance.calendarContainer.querySelectorAll('.qs-num').forEach((el, i) => {
                el.classList.remove('qs-range-end')
            });
        }

        function addMiddleLabels(startElem) {
            const sibling = startElem.nextElementSibling;
            if (sibling && !sibling.classList.contains('qs-range-end')) {
                sibling.classList.add('qs-range-middle')
                addMiddleLabels(sibling)
            }
        }

        function removeMiddleLabels(instance) {
            instance.calendarContainer.querySelectorAll('.qs-num').forEach((el, i) => {
                el.classList.remove('qs-range-middle')
            });
        }

        function addHoverLabels(startElem, hoverElem) {
            const sibling = startElem.nextElementSibling;
            if (sibling != hoverElem.nextElementSibling) {
                sibling.classList.add('qs-range-hover')
                addMiddleLabels(sibling)
            }
        }

        function removeHoverLabels(instance) {
            instance.calendarContainer.querySelectorAll('.qs-num').forEach((el, i) => {
                el.classList.remove('qs-range-hover')
            });
        }

        function setRangeClass(instance, date, cssClass) {
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();

            if (year == instance.currentYear && month == instance.currentMonth) {
                instance.calendarContainer.querySelectorAll('[data-direction="0"]').forEach((el, i) => {
                    if (el.innerHTML == day) {
                        el.classList.add(cssClass)
                    }
                });
            } else if (detectPrevMonth(instance, year, month)) {
                instance.calendarContainer.querySelectorAll('[data-direction="-1"]').forEach((el, i) => {
                    if (el.innerHTML == day) {
                        el.classList.add(cssClass)
                    }
                });
            } else if (detectNextMonth(instance, year, month)) {
                instance.calendarContainer.querySelectorAll('[data-direction="1"]').forEach((el, i) => {
                    if (el.innerHTML == day) {
                        el.classList.add(cssClass)
                    }
                });
            }
        }

        function detectPrevMonth(instance, year, month) {
            if (year == instance.currentYear && month + 1 == instance.currentMonth) return true;
            if (year + 1 == instance.currentYear && month == 11) return true;
        }

        function detectNextMonth(instance, year, month) {
            if (year == instance.currentYear && month - 1 == instance.currentMonth) return true;
            if (year - 1 == instance.currentYear && month == 0) return true;
        }
    }
}
